import React from "react";
import { Box, Typography, Paper, useTheme } from "@mui/material";
import { type TemplateEntry } from "../../../data/template-registry";

interface TemplateLocalDevProps {
  template: TemplateEntry;
}

export const TemplateLocalDev: React.FC<TemplateLocalDevProps> = ({
  template,
}) => {
  const theme = useTheme();
  const { vcs, slug } = template;

  return (
    <Box sx={{ mb: 6 }}>
      <Typography variant="h2" component="h2" gutterBottom fontWeight={600}>
        Local Development
      </Typography>
      <Paper sx={{ p: 3, bgcolor: "background.default" }}>
        {vcs.localDev?.compose ? (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              This template includes a <code>docker-compose.yml</code> that
              mirrors the production topology. Run locally with:
            </Typography>
            <Paper
              sx={{
                p: 2,
                bgcolor:
                  theme.palette.mode === "dark" ? "grey.900" : "grey.100",
                fontFamily: "monospace",
                fontSize: "0.875rem",
                overflowX: "auto",
              }}
            >
              {`cd ${vcs.repoSubdir || slug}\ndocker compose up --build`}
            </Paper>
          </Box>
        ) : (
          <Typography variant="body1" color="text.secondary">
            This template does not include a Docker Compose setup. See the
            starter repo for specific local development instructions.
          </Typography>
        )}
        {vcs.repoSubdir && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Source: <code>Rusha-Corp/starters/{vcs.repoSubdir}</code>
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};
